import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
const faqs = [{
  question: '¿Esto es asesoría legal?',
  answer: 'No. Es material educativo con scripts, checklists y mapas de riesgo. No reemplaza a un abogado, pero te da estructura para comunicarte mejor con tu equipo (realtor, lender, title). Piensa en esto como tu tablero de control, no como consejo legal.'
}, {
  question: '¿Aplica en mi estado?',
  answer: 'Sí. Los principios de protección de EMD, contingencias, y comunicación con tu equipo aplican en todo Estados Unidos. Los scripts están diseñados para funcionar sin importar el estado — porque el problema no es legal, es de comunicación.'
}, {
  question: '¿Y si ya tengo un buen realtor?',
  answer: 'Mejor aún. Este kit no reemplaza a tu agente — lo complementa. Te da el lenguaje para confirmar por escrito lo que tu realtor te dice verbalmente. Un buen agente va a agradecer que estés organizada.'
}, {
  question: '¿En qué formato viene?',
  answer: 'PDF mobile-first (lo puedes leer desde tu teléfono) + versión printable. Los scripts están listos para copiar y pegar directamente en un email o mensaje.'
}, {
  question: '¿Puedo pedir reembolso?',
  answer: 'Al ser un producto digital de descarga inmediata, todas las ventas son finales. Pero si tienes cualquier problema técnico con la descarga, te ayudamos hasta que lo resuelvas.'
}, {
  question: '¿Sirve si no es mi primera compra?',
  answer: 'Sí. Muchos repeat buyers asumen que ya saben cómo funciona todo — y ahí es donde se relajan. Este kit te da estructura para cada compra, no solo la primera.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 px-4 bg-[#0F1419] text-[#F5F0E8] border-t border-[#1A1F2E]" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-3">
          <div className="inline-flex items-center justify-center p-3 bg-[#1A1F2E] rounded-full mb-4 border border-[#D4A843]/20" data-id="element-4">
            <HelpCircle className="w-6 h-6 text-[#D4A843]" data-id="element-5" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-id="element-6">
            Preguntas Frecuentes
          </h2>
          <p className="text-[#8B8578]" data-id="element-7">
            Todo lo que necesitas saber antes de proteger tu compra.
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-8">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#1A1F2E] rounded-xl border border-[#D4A843]/10 overflow-hidden" data-id="element-9">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-[#D4A843]/5 transition-colors" data-id="element-10">
                <span className="font-medium text-lg pr-8" data-id="element-11">{faq.question}</span>
                <ChevronDown className={`w-5 h-5 text-[#D4A843] transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-12" />
              </button>

              <AnimatePresence data-id="element-13">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-14">
                    <div className="px-6 pb-6 text-[#8B8578] leading-relaxed border-t border-[#D4A843]/10 pt-4" data-id="element-15">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}